export const GET_REGISTRATION_STATSTICS = "GET_REGISTRATION_STATSTICS";
export const GET_NEW_STUDENT_STATISTICS = "GET_NEW_STUDENT_STATISTICS";
